module.exports = __webpack_public_path__ + "static/media/komponenty_mikrocontroller.e6dd8a02.svg";